<ng-container *ngIf="!isDev">
	<router-outlet></router-outlet>
</ng-container>
<ng-container *ngIf="isDev">
	<div class="constructionPassword">
		<h4>Under Construction</h4>
		<div>Enter Password to see the content</div>
		<input type="password" #password style="display: block;margin: 0 auto;margin-bottom: 7px;">
		<button (click)="clickToEnter(password)">LOGIN</button>
	</div>
</ng-container>